import {
    Paper,
    Stack,
    Title,
    Text,
    TextInput,
    PasswordInput,
    Button,
    Anchor, Modal, Center, Box, Group, Badge, Progress
} from "@mantine/core";
import { useState, useEffect } from "react";
import { message } from "antd";
import { CheckAccount, ForgetPassword, Login_Account, Sendotp_Forget_Password } from "../../../apicall";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { IconCheck, IconX } from "@tabler/icons-react";


export default function LoginCard() {
    const [mobile, setMobile] = useState("");
    const [password, setPassword] = useState("");
    const [Checkloading, setCheckloading] = useState(false);
    const [Loginloading, setLoginloading] = useState(false);
    const [showPasswordScreen, setShowPasswordScreen] = useState(false);
    const [accountModalOpen, setAccountModalOpen] = useState(false);
    const [forgetModalOpen, setForgetModalOpen] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const { dispatch } = Userauthcontexthooks();
    const [changepassword, setChangepassword] = useState({
        purpose: 'Change Password',
        newPassword: '',
        confirmNewPassword: '',
        otp: ''
    })
    const [modalStep, setModalStep] = useState(1); // 1 = Select Account, 2 = Change Password
    const [otploading, setotploading] = useState(false);
    const [passwordloading, setpasswordloading] = useState(false);
    const [otpTimer, setOtpTimer] = useState(0);
    const [latitude, setlatitude] = useState(null);
    const [longitude, setlongitude] = useState(null);

    const handleChnangepassword = (e) => {
        const { name, value } = e.target;
        setChangepassword({ ...changepassword, [name]: value })
    }

    const saveToken = (token, expiresIn) => {
        let expiryTime = Date.now();

        if (expiresIn === "30m") {
            expiryTime += 30 * 60 * 1000;
        } else if (expiresIn === "1d") {
            expiryTime += 24 * 60 * 60 * 1000;
        }
        localStorage.setItem('user', token);
        localStorage.setItem('expiryTime', expiryTime);
    };

    const Check_Account_Before_Login = async () => {
        if (!mobile) {
            message.error("Please enter mobile number");
            return;
        }
        if (!/^\d{10}$/.test(mobile)) {
            message.error("Please enter a valid 10-digit mobile number");
            return;
        }
        navigator.geolocation.getCurrentPosition(({ coords }) => {
            setlatitude(coords.latitude);
            setlongitude(coords.longitude);
        });
        try {

            setCheckloading(true);

            const data = await CheckAccount(mobile);

            // console.log(data);

            if (data.multipleAccounts) {

                setAccounts(data.accounts);

                setAccountModalOpen(true);

            } else {
                setAccounts(data.account);
                setShowPasswordScreen(true);
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {

            setCheckloading(false);

        }
    }

    const User_Login = async () => {
        if (accounts.length === 0) {
            message.error('Details not found');
            setShowPasswordScreen(false);
            return;
        }
        if (!password) {
            message.error("please fill the password");
            return;
        }
        if (!latitude || !longitude) {
            message.error('Geo Location required');
            return;
        }
        //console.log(accounts);
        if (selectedAccount === null) {
            const { userCode, acc_type, _id } = accounts[0];
            try {
                //console.log(userCode);
                setLoginloading(true);
                const data = await Login_Account(mobile, userCode, password, acc_type, _id, latitude, longitude);
                //console.log(data)
                if (data.success) {
                    message.success(data.message);
                    saveToken(data.token, data.expiresIn);
                    dispatch({
                        type: 'LOGIN', payload: {
                            token: data.token,
                            expiryTime: localStorage.getItem("expiryTime")
                        }
                    });
                    if (acc_type === 'Admin') {
                        window.location.href = "/home-admin"
                    } else if (acc_type === 'Master Distributor') {
                        window.location.href = "/home-distributor"
                    } else if (acc_type === 'Distributor') {
                        window.location.href = "/home-distributor"
                    } else if (acc_type === 'Retailer') {
                        window.location.href = "/home-retailer"
                    }
                    return;
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setLoginloading(false);
            }
        } else {
            const { userCode, acc_type, _id } = selectedAccount;
            try {
                //console.log(userCode);
                setLoginloading(true);
                const data = await Login_Account(mobile, userCode, password, acc_type, _id, latitude, longitude);
                //console.log(data)
                if (data.success) {
                    message.success(data.message);
                    saveToken(data.token, data.expiresIn);
                    dispatch({
                        type: 'LOGIN', payload: {
                            token: data.token,
                            expiryTime: localStorage.getItem("expiryTime")
                        }
                    });
                    if (acc_type === 'Admin') {
                        window.location.href = "/home-admin"
                    }
                    else if (acc_type === 'Master Distributor') {
                        window.location.href = "/home-distributor"
                    } else if (acc_type === 'Distributor') {
                        window.location.href = "/home-distributor"
                    } else if (acc_type === 'Retailer') {
                        window.location.href = "/home-retailer"
                    }
                    return;
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setLoginloading(false);
            }
        }

    }

    const requirements = [
        {
            re: /[A-Z]/,
            label: "Includes at least one uppercase letter",
        },
        {
            re: /[a-z]/,
            label: "Includes at least one lowercase letter",
        },
        {
            re: /\d/,
            label: "Includes at least one number",
        },
        {
            re: /[@$!%*?&]/,
            label: "Includes at least one special character (@$!%*?&)",
        },
    ];
    const getStrength = (password) => {
        let multiplier = password.length >= 8 ? 0 : 1;

        requirements.forEach((requirement) => {
            if (!requirement.re.test(password)) {
                multiplier += 1;
            }
        });

        return Math.max(
            100 - (100 / (requirements.length + 1)) * multiplier,
            0
        );
    };
    function PasswordRequirement({ meets, label }) {
        return (
            <Text
                component="div"
                c={meets ? "teal" : "red"}
                mt={5}
                size="sm"
            >
                <Center inline>
                    {meets ? (
                        <IconCheck size={14} stroke={1.5} />
                    ) : (
                        <IconX size={14} stroke={1.5} />
                    )}
                    <Box ml={7}>{label}</Box>
                </Center>
            </Text>
        );
    }
    const strength = getStrength(changepassword.newPassword);
    const color =
        strength === 100
            ? "teal"
            : strength > 60
                ? "lime"
                : strength > 30
                    ? "yellow"
                    : "red";
    const checks = requirements.map((requirement, index) => (
        <PasswordRequirement
            key={index}
            label={requirement.label}
            meets={requirement.re.test(changepassword.newPassword)}
        />
    ));

    const openForgetPassword = () => {
        setForgetModalOpen(true);
        setModalStep(1);
        setSelectedAccount(null);
    };

    const SentOTP = async (purpose) => {
        if (!purpose) {
            message.error('Purpose is not define');
            return;
        }
        if (!selectedAccount?.acc_type) {
            message.error('Account type missing');
            return;
        }
        if (!selectedAccount?._id) {
            message.error('User id missing');
            return;
        }
        try {
            setotploading(true);
            const body = {
                purpose: purpose,
                acc_type: selectedAccount?.acc_type,
                uid: selectedAccount?._id
            }
            const data = await Sendotp_Forget_Password(body);
            if (data.success) {
                message.success('OTP is sent in your registerd mail id');
                setOtpTimer(60); // Start 60 sec countdown
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setotploading(false);
        }

    }

    const handleChangePassword_Submit = async () => {
        if (!changepassword.newPassword || !changepassword.confirmNewPassword || !changepassword.otp) {
            message.error('All fields are required');
            return;
        }
        if (changepassword.newPassword !== changepassword.confirmNewPassword) {
            message.error("Confirm password are different");
            return;
        }
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!passwordRegex.test(changepassword.newPassword)) {
            message.error('Incorrect Password');
            return
        }
        if (!selectedAccount?.acc_type) {
            message.error('Account type missing');
            return;
        }
        if (!selectedAccount?._id) {
            message.error('User id missing');
            return;
        }
        try {
            setpasswordloading(true);
            const body = {
                newPassword: changepassword.newPassword,
                confirmNewPassword: changepassword.confirmNewPassword,
                otp: changepassword.otp,
                acc_type: selectedAccount?.acc_type,
                uid: selectedAccount?._id
            }
            const data = await ForgetPassword(body);
            if (data.success) {
                message.success(data.message);
                setForgetModalOpen(false);
                setModalStep(1);
                setSelectedAccount(null);
                setChangepassword({
                    newPassword: "",
                    confirmNewPassword: "",
                    otp: "",
                });
                // Logout_user();
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setpasswordloading(false);
        }
    }

    useEffect(() => {
        if (otpTimer <= 0) return;

        const interval = setInterval(() => {
            setOtpTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [otpTimer]);

    return (
        <>
            <Modal
                opened={accountModalOpen}
                onClose={() => setAccountModalOpen(false)}
                title="Select Account"
                centered
            >
                <Stack>

                    <Text size="sm" c="dimmed">
                        We've found multiple accounts linked with this mobile number.
                    </Text>

                    {accounts.map((account) => (
                        <Paper
                            key={account?.userCode}
                            withBorder
                            p="md"
                            radius="md"
                            style={{
                                cursor: "pointer",
                                border:
                                    selectedAccount?.userCode === account?.userCode
                                        ? "2px solid #228be6"
                                        : undefined,
                            }}
                            onClick={() => setSelectedAccount(account)}
                        >
                            <Text fw={600}>
                                {account?.userCode}
                            </Text>

                            <Text size="sm">
                                {account?.acc_type}
                            </Text>
                        </Paper>
                    ))}

                    <Button
                        fullWidth
                        disabled={!selectedAccount}
                        onClick={() => {
                            setAccountModalOpen(false);
                            setShowPasswordScreen(true);
                        }}
                    >
                        Continue
                    </Button>

                </Stack>
            </Modal>
            <Modal
                opened={forgetModalOpen}
                onClose={() => {
                    setForgetModalOpen(false);
                    setModalStep(1);
                    setSelectedAccount(null);
                }}
                title={
                    modalStep === 1
                        ? "Select Account"
                        : "Change Password"
                }
                centered
                size="lg"
            >
                {/* ===========================
        STEP 1 : SELECT ACCOUNT
    ============================ */}
                {modalStep === 1 && (
                    <Stack>

                        <Text size="sm" c="dimmed">
                            Select the account whose password you want to change.
                        </Text>

                        {accounts.map((account) => (
                            <Paper
                                key={account.userCode}
                                withBorder
                                radius="md"
                                p="md"
                                style={{
                                    cursor: "pointer",
                                    border:
                                        selectedAccount?.userCode === account.userCode
                                            ? "2px solid #228be6"
                                            : undefined,
                                }}
                                onClick={() => setSelectedAccount(account)}
                            >
                                <Group justify="space-between">
                                    <div>
                                        <Text fw={700}>
                                            {account.userCode}
                                        </Text>

                                        <Text size="sm" c="dimmed">
                                            {account.userName}
                                        </Text>
                                    </div>

                                    <Badge color="blue">
                                        {account.acc_type}
                                    </Badge>
                                </Group>
                            </Paper>
                        ))}

                        <Button
                            fullWidth
                            disabled={!selectedAccount}
                            onClick={() => setModalStep(2)}
                        >
                            Continue
                        </Button>

                    </Stack>
                )}

                {/* ===========================
        STEP 2 : CHANGE PASSWORD
    ============================ */}
                {modalStep === 2 && (
                    <Stack>
                        <Paper
                            withBorder
                            p="sm"
                            radius="md"
                            bg="gray.0"
                        >
                            <Text fw={700} ml={'xs'}>
                                {selectedAccount?.userName}
                            </Text>

                            <Text size="sm" c="dimmed" ml={'xs'}>
                                {selectedAccount?.userCode}
                            </Text>

                            <Badge ml={'xs'}>
                                {selectedAccount?.acc_type}
                            </Badge>
                        </Paper>

                        <TextInput
                            label="New Password"
                            size="md"
                            withAsterisk
                            type="password"
                            minLength={8}
                            name="newPassword"
                            value={changepassword.newPassword}
                            onChange={handleChnangepassword}
                        />

                        {changepassword.newPassword !== "" && (
                            <>
                                <Progress
                                    value={strength}
                                    color={color}
                                    size="sm"
                                    radius="xl"
                                />

                                <Text size="xs" fw={600}>
                                    Password Strength :
                                    {" "}
                                    {strength === 100
                                        ? "Strong"
                                        : strength > 60
                                            ? "Good"
                                            : strength > 30
                                                ? "Weak"
                                                : "Very Weak"}
                                </Text>

                                <PasswordRequirement
                                    label="Has at least 8 characters"
                                    meets={
                                        changepassword.newPassword.length >= 8
                                    }
                                />

                                {checks}
                            </>
                        )}

                        <TextInput
                            label="Confirm Password"
                            size="md"
                            withAsterisk
                            name="confirmNewPassword"
                            value={changepassword.confirmNewPassword}
                            onChange={handleChnangepassword}
                        />

                        <Group align="end">

                            <TextInput
                                style={{ flex: 1 }}
                                label="OTP"
                                placeholder="Enter OTP"
                                name="otp"
                                value={changepassword.otp}
                                onChange={handleChnangepassword}
                                withAsterisk
                                type="password"
                            />

                            {otpTimer > 0 ? (
                                <Button disabled variant="light">
                                    {otpTimer}s
                                </Button>
                            ) : (
                                <Button
                                    loading={otploading}
                                    onClick={() =>
                                        SentOTP(
                                            "Change Password",
                                            selectedAccount
                                        )
                                    }
                                    variant="outline"
                                >
                                    Send OTP
                                </Button>
                            )}

                        </Group>

                        {otpTimer > 0 && (
                            <Text size="xs" c="dimmed" ta={'end'}>
                                Resend OTP in {otpTimer} seconds
                            </Text>
                        )}

                        <Group grow mt="md">

                            <Button
                                variant="default"
                                onClick={() => setModalStep(1)}
                            >
                                Back
                            </Button>

                            <Button
                                loading={passwordloading}
                                onClick={() =>
                                    handleChangePassword_Submit(
                                        selectedAccount
                                    )
                                }
                            >
                                Change Password
                            </Button>

                        </Group>

                    </Stack>
                )}
            </Modal>

            <Paper
                radius="xl"
                shadow="xl"
                p={40}
                w="100%"
                maw={450}
            >
                <Stack>

                    <div>
                        <Title order={2}>
                            Welcome Back
                        </Title>

                        <Text c="dimmed">
                            Login to continue
                        </Text>
                    </div>

                    <TextInput
                        label="Mobile Number"
                        placeholder="Enter mobile number"
                        size="lg"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        disabled={showPasswordScreen}
                        maxLength={10}
                        withAsterisk
                    />

                    {showPasswordScreen && (
                        <>
                            {
                                selectedAccount !== null && (
                                    <Paper
                                        p="sm"
                                        withBorder
                                        radius="md"
                                        bg="gray.0"
                                        shadow="xs"
                                    >
                                        <Text size="sm" fw={500}>
                                            Account:   <span>
                                                {selectedAccount?.userCode}
                                            </span>
                                        </Text>
                                        <Text size="xs" c="dimmed">
                                            {selectedAccount?.acc_type}
                                        </Text>
                                    </Paper>
                                )
                            }
                            <PasswordInput
                                label="Password"
                                placeholder="Enter password"
                                size="lg"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                withAsterisk
                            />

                            <Anchor
                                size="sm"
                                ta="right"
                                onClick={openForgetPassword}
                            >
                                Forgot Password?
                            </Anchor>

                            <Button
                                size="lg"
                                radius="md"
                                fullWidth
                                onClick={User_Login}
                                loading={Loginloading}
                            >
                                Login
                            </Button>
                            {
                                selectedAccount &&
                                <Button
                                    variant="subtle"
                                    fullWidth
                                    onClick={() => {
                                        setShowPasswordScreen(false);
                                        setSelectedAccount(null);
                                    }}
                                >
                                    Change Account
                                </Button>
                            }

                        </>
                    )}

                    {!showPasswordScreen && (
                        <Button
                            size="lg"
                            radius="md"
                            fullWidth
                            onClick={Check_Account_Before_Login}
                            loading={Checkloading}
                        >
                            Continue
                        </Button>
                    )}

                    {/* <Text
                        c="dimmed"
                        ta="center"
                        size="xs"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                        (window.location.href =
                            "https://gvinfotech.org")
                        }
                    >
                        Design & Developed by GV InfoTech.org
                    </Text> */}

                </Stack>
            </Paper>
        </>
    );
}